import {
  updateCampaignNameService,
  deleteCampaignService,
  getUsersDataFilterService,
  getCampaignsNamesOnlyService,
  getAssetsService,
  getCampaignsListService,
  getCampaignsDashboardGraphDataService,
  createEmailService,
  createAssetAndCampaignService,
  createAIEmailAndCampaignService,
  getAIEmailService,
  updateAssetAndCampaignService,
  setAIEmailReviewService,
  saveAsDraftAiEmailService,
} from 'modules/Services/CampaignsService';
import {
  getRecommendedListsService,
  getRecommendedPeopleService,
  searchPeopleService,
  searchListService,
  dynamicAudienceSearchService,
  recommendedPeopleExportService,
} from 'modules/Services/AudienceService';
import {
  CAMPAIGNS_LIST,
  CAMPAIGN_NAME_UPDATE,
  CAMPAIGN_SENT_EDITIONS,
  CAMPAIGN_DELETE,
  CREATE_CAMPAIGN_RECOMMENDED_LISTS,
  CREATE_CAMPAIGN_RECOMMENDED_CONTACTS,
  SEARCH_CAMPAIGNS_LIST,
  GET_CAMPAIGNS_NAMES_ONLY,
  TEST_CAMPAIGN_SEARCH_TERM,
  ADHOC,
  CAMPAIGN_NAME_DELETE,
  SELECTED_RECOMMENDED_CONTACTS,
  AIEMAIL,
} from 'constants/types/campaignTypes';
import store from '../../../store/index';
import { IContactItem } from './../Audience/interface';
import { serializeList, serializeContacts } from './../Audience/utils';
import { ICampaignItem, ICampaignsName, IGraphData, SelectOption } from '../interfaces';
import { getAllTimeDates, getDay, getMonthDates, getQuarterDates, getWeekDates, objectToQueryParams } from 'utils';
import {
  CAMPAIGNS_GRAPH_DATA,
  RECOMMENDED_PEOPLE_SEARCH,
  RECOMMENDED_LIST_SEARCH,
  BROWSER_EDITIONS_OF_CAMPAIGN,
  EMAIL_BROWSER,
  DESIGN,
  DYNAMIC_AUDIENCE_MATCHING,
  ALL_ARTICLES_IN_EDITION,
  SEARCH_ARTICLES,
} from 'constants/actionTypes';
import { getSearchArticlesService } from '../../Services/SearchService';
import { IArticlesItem } from 'modules/Content/interfaces';
import { serializeArticles } from 'modules/Content/WhatsHappeningNow/utils';
import { getTemplatesService } from 'modules/Services/AssetService';
import { TEMPLATES_TYPE } from './Components/AdhocTemplates/constants';
import { closeOverlay } from './../../GlobalActions';
import { ASSET_DETAILS, EMAIL_LIST } from 'constants/types';
import { createNewCampaignSerialize, resetAllData } from '../utils';
import { getQueryEmailId } from 'modules/EmailBrowser/utils';
import { getEditionArticles } from '../Edition/actions';
import { offset } from 'highcharts';
import { SAVING_DESIGN } from '../../../constants/actionTypes';
import { IDesignItem } from 'modules/Design/Interfaces';
import { message } from 'antd';

export const getCampaignsDashboardGraphData = (params: any, callback?: any) => {
  getCampaignsDashboardGraphDataService(params).then((res: any) => {
    const serializedData: IGraphData = res.data;
    store.dispatch({
      type: CAMPAIGNS_GRAPH_DATA.LOAD_SUCCESS,
      start_date: params.start_date,
      end_date: params.end_date,
      user_id: params.user_id,
      payload: {
        data: serializedData,
      },
    });

    if (callback)
      callback({
        accumulated_campaigns_clicks: res.data.accumulated_campaigns_clicks,
        accumulated_campaigns_opens: res.data.accumulated_campaigns_opens,
      });
  });
};
export const getCampaignList = (params: any, isFiltered: boolean) => {
  if (params?.offset === 0) {
    store.dispatch({
      type: CAMPAIGNS_LIST.RESET,
    });
  }
  store.dispatch({
    type: CAMPAIGNS_LIST.LOAD,
  });
  getCampaignsListService(params)
    .then(({ data }: any) => {
      if (!data.message) {
        const campaignsList: ICampaignItem[] = data.campaigns;
        store.dispatch({
          type: CAMPAIGNS_LIST.SUCCESS,
          payload: { campaignsList: campaignsList, isFiltered: isFiltered, totalCount: data.total_count },
        });
      } else {
        // α case in search
        store.dispatch({
          type: CAMPAIGNS_LIST.ERROR_SEARCH_TERM,
          message: data.message,
          success: false,
        });
        store.dispatch({
          type: CAMPAIGNS_LIST.ERROR_SEARCH_TERM_LOADING,
        });
      }
    })
    .catch((err) => {
      console.log('getCampaignList: ', err);
      if (err.message !== 'Operation canceled due to new request.')
        store.dispatch({
          type: CAMPAIGNS_LIST.FAIL,
          payload: Array<ICampaignItem>(),
        });
      // show error alert on frontend
    });
};

export const resetCampaignFilters = () => {
  store.dispatch({
    type: EMAIL_LIST.RESET_CAMPAIGN_FILTERS,
  });
};

export const updateCampaignName = (campaignId: string, campaignName: string, campaignSubject: string) => {
  store.dispatch({
    type: CAMPAIGN_NAME_UPDATE.LOAD,
    payload: campaignName,
  });
  store.dispatch({ type: EMAIL_LIST.UPDATE_CAMPAIGN_NAME, payload: { campaignName } });

  updateCampaignNameService(campaignId, campaignName, campaignSubject)
    .then((res: any) => {
      store.dispatch({
        type: CAMPAIGN_NAME_UPDATE.SUCCESS,
        payload: [campaignId, campaignName, campaignSubject],
      });
      store.dispatch({
        type: GET_CAMPAIGNS_NAMES_ONLY.UPDATE_NAME,
        payload: [
          {
            campaign_id: campaignId,
            name: campaignName,
          },
        ],
      });
    })
    .catch((err: any) => {
      console.log(err);
      store.dispatch({
        type: CAMPAIGN_NAME_UPDATE.FAIL,
      });
      // show error alert on frontend
    });
};

export const deleteCampaign = (index: number, campaignId: string, assetCount: number) => {
  deleteCampaignService(campaignId).then((response) => {
    if (response.status === 200) {
      store.dispatch({
        type: CAMPAIGN_DELETE.SUCCESS,
        payload: parseInt(campaignId),
      });
      store.dispatch({
        type: CAMPAIGN_NAME_DELETE.SUCCESS,
        payload: parseInt(campaignId),
      });
      removeEmailsFromBrowserOfDeletedCampaign(campaignId);
      decreaseAssetCountForCampaignDelete(assetCount);
    }
  });
};

export const decreaseAssetCountForCampaignDelete = (count: number) => {
  store.dispatch({
    type: CAMPAIGN_DELETE.DECREMENT_ASSET_COUNT,
    payload: count,
  });
};

export const removeEmailsFromBrowserOfDeletedCampaign = (campaignId: string) => {
  store.dispatch({
    type: EMAIL_BROWSER.REMOVE_EMAILS_OF_CAMPAIGN,
    payload: campaignId,
  });
};

export const getUsersDataFilters = (callback?: any, campaignId?: any) => {
  let params = '';
  if (campaignId && campaignId !== '') {
    params = objectToQueryParams({ campaign_id: campaignId });
  }
  getUsersDataFilterService(params)
    .then((res) => {
      if (res?.data?.length > 0) {
        let users = res.data.map((user: any) => {
          let object: any = {};
          if (user.first_name || user.last_name || user?.fullname) {
            object.label = user?.fullname && !(user.first_name && user.last_name) ? `by ${user.fullname}` : `by ${user.first_name} ${user.last_name}`;
          } else {
            object.label = 'by ' + user.email;
          }
          object.value = user.userid;
          object.active = user.active_status;
          return object;
        });
        users = [{ label: 'by User', value: 'default' }, ...users];

        if (callback) callback(users);
        else {
          if (campaignId) store.dispatch({ type: CAMPAIGNS_LIST.SET_EMAIL_USERS, emailUsers: users });
          else store.dispatch({ type: CAMPAIGNS_LIST.SET_USERS, campaignsUsers: users });
        }
      }
      store.dispatch({
        type: EMAIL_LIST.RESET,
        payload: false,
      });
    })
    .catch((err) => {
      console.log('Users Error : ', err);
      // store.dispatch({
      //   type: CAMPAIGNS_FILTER_DATA.FAIL_USERS,
      // });
    });
};

export const getSentEditionsInCampaign = (id: any, assetType?: string) => {
  // data["result_limit"],data["result_offset"]
  store.dispatch({
    type: CAMPAIGN_SENT_EDITIONS.LOAD,
  });
  store.dispatch({
    type: BROWSER_EDITIONS_OF_CAMPAIGN.LOAD,
  });
  // getSentEditionsInCampaignService(id)
  //   .then((res: any) => {
  //     const sendEditionsinCampaign: IVersion[] = res.data.versions || [];
  //     const assetName: string = res.data.asset_name;
  //     const assetType: string = res.data.asset_type;
  //     const assetKeywords: string = res.data.asset_keywords;
  //     const assetBrowserEditions: any = serializeEditionsForAssetBrowser(res.data.versions);
  //     store.dispatch({
  //       type: BROWSER_EDITIONS_OF_CAMPAIGN.LOAD_SUCCESS,
  //       payload: assetBrowserEditions,
  //     });
  //     store.dispatch({
  //       type: CAMPAIGN_SENT_EDITIONS.LOAD_SUCCESS,
  //       payload: {
  //         assetName,
  //         assetType,
  //         assetKeywords,
  //         sendEditionsinCampaign,
  //       },
  //     });
  //     if (assetType === ASSET_TYPE.CUSTOM) {
  //       store.dispatch({
  //         type: CAMPAIGNS_LIST.UPDATE_THUMBNAIL,
  //         campaign_id: getQueryCampaignId(),
  //         image: res.data.versions[0].thumbnail[0],
  //       });
  //     }
  //   })
  //   .catch((error: any) => {
  //     console.log(error);
  //     store.dispatch({
  //       type: CAMPAIGN_SENT_EDITIONS.LOAD_FAIL,
  //     });
  //     store.dispatch({
  //       type: BROWSER_EDITIONS_OF_CAMPAIGN.LOAD_FAIL,
  //     });
  //     // show error alert on frontend
  //   });
};

export const getRecommendedLists = (offset?: number, limit?: number) => {
  store.dispatch({
    type: CREATE_CAMPAIGN_RECOMMENDED_LISTS.LOAD,
  });
  if (!offset && offset !== 0) {
    offset = 0;
  }
  if (!limit) {
    limit = 20;
  }
  if (offset === 0) {
    store.dispatch({
      type: CREATE_CAMPAIGN_RECOMMENDED_LISTS.CLEAR_DATA,
    });
  }
  getRecommendedListsService(offset, limit)
    .then(({ data }) => {
      // const recommendedLists = data;
      const recommendedLists = serializeList(data?.data);
      store.dispatch({
        type: CREATE_CAMPAIGN_RECOMMENDED_LISTS.SUCCESS,
        payload: recommendedLists,
        totalLists: data?.total_lists,
      });
    })
    .catch((err) => {
      console.log(err);
      if (!(err.message && err.message.includes('Operation canceled due to new request.'))) {
        store.dispatch({
          type: CREATE_CAMPAIGN_RECOMMENDED_LISTS.FAIL,
        });
      }
    });
};

export const resetRecommendedLists = () => {
  store.dispatch({ type: CREATE_CAMPAIGN_RECOMMENDED_LISTS.RESET });
};

// export const resetFilteredCampaignsData = () => {
//   store.dispatch({ type: CAMPAIGNS_FILTER_DATA.RESET });
//   // store.dispatch({ type: CAMPAIGNS_GRAPH_DATA.CLEAR });
// // };

export const campaignFilterChange = (value: SelectOption) => {
  // store.dispatch({
  //   type: CAMPAIGNS_FILTER_DATA.SET_CAMPAIGN,
  //   payload: value,
  // });
};

export const userFilterChange = (value: SelectOption) => {
  // store.dispatch({
  //   type: CAMPAIGNS_FILTER_DATA.SET_USER,
  //   payload: value,
  // });
  graphUserChanged(value.value);
};

export const datesFilterChange = (value: SelectOption) => {
  // store.dispatch({
  //   type: CAMPAIGNS_FILTER_DATA.SET_DATE,
  //   payload: value,
  // });
  let datesObject: any = {};

  switch (value.value) {
    case 'all':
      datesObject = getAllTimeDates();
      break;

    case 'qtr':
      datesObject = getQuarterDates();
      break;

    case 'month':
      datesObject = getMonthDates();
      break;

    case 'week':
      datesObject = getWeekDates(7);
      break;

    case 'day':
      datesObject = getDay(2);
      break;

    default:
      break;
  }
  store.dispatch({
    type: CAMPAIGNS_GRAPH_DATA.SET_DATES,
    ...datesObject,
  });
};

export const graphUserChanged = (userId: any) => {
  store.dispatch({
    type: CAMPAIGNS_GRAPH_DATA.SET_USER,
    user_id: userId,
  });
};

export const setSelectAllRecommendedContacts = () => {
  store.dispatch({
    type: CREATE_CAMPAIGN_RECOMMENDED_CONTACTS.SET_SELECT_ALL,
  });
};

export const resetSelectAllRecommendedContacts = () => {
  store.dispatch({
    type: CREATE_CAMPAIGN_RECOMMENDED_CONTACTS.RESET_SELECT_ALL,
  });
};

export const getRecommendedPeople = (
  offset?: number,
  limit?: number,
  selectAllFlag?: boolean,
  listId?: string,
  excludedIds?: string[],
  selectAll?: boolean,
) => {
  store.dispatch({
    type: CREATE_CAMPAIGN_RECOMMENDED_CONTACTS.LOAD,
  });
  if (!offset && offset !== 0) {
    offset = store?.getState().recommendedPeople?.data?.length ?? 0;
  }
  if (offset === 0) {
    store.dispatch({ type: CREATE_CAMPAIGN_RECOMMENDED_CONTACTS.CLEAR_DATA });
  }
  if (!limit) {
    limit = 50;
  }
  if (selectAll) {
    setSelectAllRecommendedContacts();
  }

  return getRecommendedPeopleService(offset, limit, selectAllFlag, listId, excludedIds)
    .then(({ data }) => {
      const recommendedPeople: IContactItem[] = serializeContacts(data?.data);
      store.dispatch({
        type: CREATE_CAMPAIGN_RECOMMENDED_CONTACTS.SUCCESS,
        payload: recommendedPeople,
        totalContacts: data?.total_contacts,
        isSelectAll: selectAll,
      });
      // pass the selected contacts to the store
      if (selectAll) {
        // let recommendedContacts = [...store.getState().recommendedPeople.data, ...recommendedPeople];
        let recommendedContacts = [...store.getState().recommendedPeople.data];
        setSelectedSelectAllRecommendedContacts(recommendedContacts);
      }
    })
    .catch((err) => {
      console.log(err);
      if (!(err.message && err.message.includes('Operation canceled due to new request.'))) {
        store.dispatch({ type: CREATE_CAMPAIGN_RECOMMENDED_CONTACTS.FAIL });
      }
    });
};

export const setSelectedRecommendedContacts = (selectedContact: any, object?: any) => {
  store.dispatch({
    type: CREATE_CAMPAIGN_RECOMMENDED_CONTACTS.SET_SELECTED_CONTACTS,
    selectedContact,
  });
  console.log('selectedContact', selectedContact);
  console.log('object', object);
  store.dispatch({
    type: SELECTED_RECOMMENDED_CONTACTS.SET,
    payload: { ...selectedContact },
    ...object,
  });
};

export const resetSelectedRecommendedContacts = () => {
  store.dispatch({
    type: CREATE_CAMPAIGN_RECOMMENDED_CONTACTS.RESET_SELECTED_CONTACTS,
  });
};

export const resetRecommendedContacts = () => {
  store.dispatch({ type: CREATE_CAMPAIGN_RECOMMENDED_CONTACTS.RESET });
};

export const getCampaignsNamesOnly = (params: any) => {
  let queryParams = {};
  if (params) {
    queryParams = objectToQueryParams(params);
  }
  store.dispatch({
    type: GET_CAMPAIGNS_NAMES_ONLY.LOAD,
    ...(params.search_campaign ? { search_campaign: params.search_campaign } : {}),
  });
  getCampaignsNamesOnlyService(queryParams)
    .then(({ data }) => {
      const campaignNames: ICampaignsName[] = data.campaigns;
      store.dispatch({
        type: GET_CAMPAIGNS_NAMES_ONLY.SUCCESS,
        payload: campaignNames,
        totalCount: data.total_count,
      });
    })
    .catch((err) => {
      console.log(err);
      if (!(err.message && err.message.includes('Operation canceled due to new request.'))) {
        store.dispatch({
          type: GET_CAMPAIGNS_NAMES_ONLY.FAIL,
        });
      }
    });
};

export const resetCampaignsNamesOnly = () => {
  store.dispatch({ type: GET_CAMPAIGNS_NAMES_ONLY.RESET });
};

export const setSearchCampaignName = (name: string) => {
  store.dispatch({
    type: SEARCH_CAMPAIGNS_LIST.SET_SEARCH,
    search: name,
  });
};

// export const setFilterToTrue = () => {
//   store.dispatch({
//     type: CAMPAIGNS_FILTER_DATA.SET_IS_FILTER_TRUE,
//   });
// };

export const getSearchedCampaigns = (params: any) => {
  store.dispatch({
    type: SEARCH_CAMPAIGNS_LIST.LOAD,
  });
  const queryParams = objectToQueryParams(params);
  getAssetsService(queryParams)
    .then((res) => {
      const campaignsList: ICampaignItem[] = res.data;
      store.dispatch({
        type: SEARCH_CAMPAIGNS_LIST.SUCCESS,
        payload: campaignsList,
      });
    })
    .catch((err) => {
      console.log('Err : ', err);
      store.dispatch({
        type: SEARCH_CAMPAIGNS_LIST.FAIL,
      });
    });
};

export const testCampaignKeywords = (searchTerms: string[]) => {
  store.dispatch({
    type: TEST_CAMPAIGN_SEARCH_TERM.LOAD,
  });
  const object = {
    searchTerms: searchTerms.map((word: string) => word.replaceAll('#', '')),
    offset: 0,
    limit: 50,
  };
  getSearchArticlesService(object)
    .then((res) => {
      const serializedData: IArticlesItem[] = serializeArticles(res.data['articles']);
      const articlesCount = res.data['articles_count'];
      store.dispatch({
        type: TEST_CAMPAIGN_SEARCH_TERM.SUCCESS,
        payload: serializedData,
        article_count: articlesCount,
      });
      store.dispatch({ type: TEST_CAMPAIGN_SEARCH_TERM.SUCCESS });
    })
    .catch((err) => {
      console.error(err);
      store.dispatch({
        type: TEST_CAMPAIGN_SEARCH_TERM.FAIL,
      });
    });
};

export const resetCampaigns = () => {
  store.dispatch({
    type: CAMPAIGNS_LIST.RESET,
  });
};

export const searchPeople = (
  offset?: number,
  limit?: number,
  searchTerm?: string,
  isKeywords?: boolean,
  selectAllFlag?: boolean,
  listId?: string,
  excludedContacts?: string[],
  selectAll?: boolean,
) => {
  if (isKeywords === true) {
    if (searchTerm?.length == 0) {
      store.dispatch({
        type: CREATE_CAMPAIGN_RECOMMENDED_CONTACTS.LOAD,
      });
    } else {
      store.dispatch({
        type: DYNAMIC_AUDIENCE_MATCHING.LOAD,
      });
    }
  } else {
    store.dispatch({
      type: RECOMMENDED_PEOPLE_SEARCH.LOAD,
    });
  }
  if (!offset && offset != 0) {
    offset = 0;
  }
  if (!limit) limit = 50;
  if (!searchTerm) searchTerm = '';
  if (offset == 0) {
    if (isKeywords) {
      if (searchTerm?.length == 0) {
        store.dispatch({
          type: CREATE_CAMPAIGN_RECOMMENDED_CONTACTS.CLEAR_DATA,
        });
      } else {
        store.dispatch({
          type: DYNAMIC_AUDIENCE_MATCHING.CLEAR_DATA,
        });
      }
    } else {
      store.dispatch({ type: RECOMMENDED_PEOPLE_SEARCH.CLEAR_DATA });
    }
  }

  searchPeopleService(offset, limit, searchTerm, isKeywords, selectAllFlag, listId, excludedContacts)
    .then((res) => {
      if (!res.data.message) {
        let contacts = serializeContacts(res?.data?.data);
        if (isKeywords === true) {
          if (searchTerm?.length === 0) {
            store.dispatch({
              type: CREATE_CAMPAIGN_RECOMMENDED_CONTACTS.SUCCESS,
              // type: DYNAMIC_AUDIENCE_MATCHING.SUCCESS,
              payload: contacts,
              totalContacts: res?.data?.total_contacts,
            });
          } else {
            store.dispatch({
              // type: CREATE_CAMPAIGN_RECOMMENDED_CONTACTS.SUCCESS,
              type: DYNAMIC_AUDIENCE_MATCHING.SUCCESS,
              payload: contacts,
              totalContacts: res?.data?.total_contacts,
            });
          }
          // passing the total contacts to the store
          // if (selectAll) {
          //   // let recommendedContacts = [...store.getState().recommendedPeople.data, ...contacts];
          //   let recommendedContacts = [...store.getState().recommendedPeople.data];
          //   setSelectedSelectAllRecommendedSearchedContacts(recommendedContacts);
          // }
        } else {
          store.dispatch({
            type: RECOMMENDED_PEOPLE_SEARCH.SUCCESS,
            payload: contacts,
            totalContacts: res?.data?.total_contacts,
          });
          // passing the total contacts to the store
          if (selectAll) {
            // let recommendedSearchedContacts = [...store.getState().searchRecommendedPeople.data, ...contacts];
            let recommendedSearchedContacts = [...store.getState().searchRecommendedPeople.data];
            setSelectedSelectAllRecommendedSearchedContacts(recommendedSearchedContacts);
          }
        }
      } else {
        // α case in search
        store.dispatch({
          type: RECOMMENDED_PEOPLE_SEARCH.ERROR_SEARCH_TERM,
          message: res?.data?.message,
          success: false,
        });
        store.dispatch({
          type: RECOMMENDED_PEOPLE_SEARCH.ERROR_SEARCH_TERM_LOADING,
        });
      }
    })
    .catch((err) => {
      console.log(err);
      if (!(err.message && err.message.includes('Operation canceled due to new request.'))) {
        if (isKeywords === true) {
          store.dispatch({
            type: CREATE_CAMPAIGN_RECOMMENDED_CONTACTS.FAIL,
          });
        } else {
          store.dispatch({
            type: RECOMMENDED_PEOPLE_SEARCH.FAIL,
          });
        }
      }
    });
};

export const setDynamicKeywordsAction = (dynamicAudienceKeywords?: string[]) => {
  store.dispatch({
    type: DYNAMIC_AUDIENCE_MATCHING.DYNAMIC_KEYWORDS,
    dynamicKeywords: dynamicAudienceKeywords,
  });
};

export const recommendedPeopleExport = (searchTerm?: string, keywords?: string) => {
  return recommendedPeopleExportService(searchTerm, keywords);
};

export const dynamicAudienceSearch = (
  offset: number,
  limit: number,
  searchTerm: string,
  dynamicKeywords: string,
  selectAllFlag?: boolean,
  listId?: string,
  excludedContacts?: string[],
  selectAll?: boolean,
) => {
  store.dispatch({
    type: DYNAMIC_AUDIENCE_MATCHING.LOAD,
  });

  if (!offset && offset != 0) {
    offset = 0;
  }
  if (!limit) limit = 50;

  if (offset === 0) {
    store.dispatch({ type: DYNAMIC_AUDIENCE_MATCHING.CLEAR_DATA });
  }

  dynamicAudienceSearchService(offset, limit, searchTerm, dynamicKeywords, selectAllFlag, listId, excludedContacts)
    .then((res) => {
      let contacts = serializeContacts(res?.data?.data);
      store.dispatch({
        type: DYNAMIC_AUDIENCE_MATCHING.SUCCESS,
        payload: contacts,
        totalContacts: res?.data?.total_contacts,
      });
      // passing the data in selectedContacts reducer
      if (selectAll) {
        // let recommendedDynamicContacts = [...store.getState().recommendedPeople.dynamicAudienceData, ...contacts];
        let recommendedDynamicContacts = [...store.getState().recommendedPeople.dynamicAudienceData];
        setSelectedSelectAllRecommendedDynamicContacts(recommendedDynamicContacts);
      }
    })
    .catch((err) => {
      console.log(err);
      if (!(err.message && err.message.includes('Operation canceled due to new request.'))) {
        store.dispatch({
          type: DYNAMIC_AUDIENCE_MATCHING.FAIL,
        });
      }
    });
};

export const clearPeopleSearch = () => {
  store.dispatch({
    type: RECOMMENDED_PEOPLE_SEARCH.CLEAR,
  });
  store.dispatch({
    type: DYNAMIC_AUDIENCE_MATCHING.SEARCH_TERM,
    searchTerm: '',
  });
};

export const searchLists = (searchTerm: string, isKeywords?: boolean, offset?: number, limit?: number) => {
  if (isKeywords === true) {
    store.dispatch({
      type: CREATE_CAMPAIGN_RECOMMENDED_LISTS.LOAD,
    });
  } else {
    store.dispatch({
      type: RECOMMENDED_LIST_SEARCH.LOAD,
    });
  }
  if (!offset && offset !== 0) {
    offset = 0;
  }
  if (!limit) {
    limit = 100;
  }
  if (offset === 0) {
    if (isKeywords === true) {
      store.dispatch({
        type: CREATE_CAMPAIGN_RECOMMENDED_LISTS.CLEAR_DATA,
      });
    } else {
      store.dispatch({
        type: RECOMMENDED_LIST_SEARCH.CLEAR_DATA,
      });
    }
  }
  searchListService(offset, limit, searchTerm, isKeywords)
    .then((res) => {
      if (isKeywords === true) {
        store.dispatch({
          type: CREATE_CAMPAIGN_RECOMMENDED_LISTS.SUCCESS,
          payload: serializeList(res?.data?.data),
          totalLists: res?.data?.total_lists,
        });
      } else {
        if (!res.data.message) {
          store.dispatch({
            type: RECOMMENDED_LIST_SEARCH.SUCCESS,
            payload: serializeList(res?.data?.data),
            totalLists: res?.data?.total_lists,
          });
        } else {
          // α case in search
          store.dispatch({
            type: RECOMMENDED_LIST_SEARCH.ERROR_SEARCH_TERM,
            message: res?.data?.message,
            success: false,
          });
          store.dispatch({
            type: RECOMMENDED_LIST_SEARCH.ERROR_SEARCH_TERM_LOADING,
          });
        }
      }
    })
    .catch((err) => {
      console.log(err);
      if (!(err.message && err.message.includes('Operation canceled due to new request.'))) {
        if (isKeywords === true) {
          store.dispatch({
            type: CREATE_CAMPAIGN_RECOMMENDED_LISTS.FAIL,
          });
        } else {
          store.dispatch({
            type: RECOMMENDED_LIST_SEARCH.FAIL,
          });
        }
      }
    });
};

export const clearListSearch = () => {
  store.dispatch({
    type: RECOMMENDED_LIST_SEARCH.CLEAR,
  });
};

export const getTemplates = (data: any, callback?: any) => {
  // Get templates all, or based on searchterm
  store.dispatch({
    type: ADHOC.TEMPLATES_LOAD,
  });

  getTemplatesService(data)
    .then((res) => {
      if (!res.data.message) {
        if (data['searchValue'] === '') {
          store.dispatch({
            type: ADHOC.TEMPLATES_SUCCESS,
            templateType: data.templateType,
            featured: res.data.featured_templates,
            shared: res.data.shared_templates,
            my_templates: res.data.my_templates,
          });
        } else {
          store.dispatch({
            type: ADHOC.FILTER_TEMPLATE,
            templateType: data.templateType,
            featured: res.data.featured_templates,
            shared: res.data.shared_templates,
            my_templates: res.data.my_templates,
          });
        }
        if (callback) {
          if (data.templateType === TEMPLATES_TYPE.FEATURED) callback();
          if (data.templateType === TEMPLATES_TYPE.MY_TEMPLATES) callback();
          if (data.templateType === TEMPLATES_TYPE.SHARED) callback();
        }
      } else {
        // α case in search
        store.dispatch({
          type: ADHOC.ERROR_SEARCH_TERM,
          payload: { message: res.data.message, success: false },
        });
        store.dispatch({
          type: ADHOC.ERROR_SEARCH_TERM_LOADING,
        });
      }
    })
    .catch((err) => {
      console.log(err);
      if (!(err.message && err.message.includes('Operation canceled due to new request.'))) {
        store.dispatch({
          type: ADHOC.TEMPLATES_FAIL,
        });
      }
    });
};

export const saveAdHocAssetAPI = (campaignId: number, assetName: string, templateId: number) => {
  // Save adhoc asset with template associations
  store.dispatch({
    type: ADHOC.SAVE_LOAD,
  });
  createEmailService(assetName, campaignId.toString(), templateId)
    .then((res: any) => {
      if (res.status === 200) {
        let url = '';
        store.dispatch({
          type: DESIGN.RESET,
        });
        resetAllData();
        console.log('getEditionArticles CampaignAssets > actions 1');
        getEditionArticles(res.data.email_id);
        if (window.location.pathname.includes('campaigns/content'))
          url = `/campaigns/editionedit/design/?campaign_id=${res.data.campaign_id}&email_id=${res.data.email_id}`;
        else url = `/campaigns/content/?campaign_id=${res.data.campaign_id}&email_id=${res.data.email_id}`;
        store.dispatch({
          type: ADHOC.RESET_URL,
          redirectUrl: url,
        });
        store.dispatch({
          type: CAMPAIGNS_LIST.UPDATE_ASSET_COUNT,
          campaign_id: campaignId,
          add: true,
        });
        store.dispatch({
          type: GET_CAMPAIGNS_NAMES_ONLY.SUCCESS,
          payload: [
            {
              campaign_id: res.data.campaign_id,
              name: res.data.campaign_data.campaign_name,
            },
          ],
          newlyAdded: true,
        });
      }

      closeOverlay();
    })
    .catch((err) => {
      console.log(err);
      closeOverlay();
      store.dispatch({
        type: ADHOC.SAVE_FAIL,
      });
    });
};

export const saveAdHocAssetAPIAndCampaign = (
  assetName: string,
  campaignName: string,
  keywords?: any[],
  contact_ids?: any[],
  list_ids?: any[],
  templateId?: number,
) => {
  // Save adhoc asset with template associations
  store.dispatch({
    type: ADHOC.SAVE_LOAD,
  });
  createAssetAndCampaignService(assetName, campaignName, keywords, contact_ids, list_ids, templateId)
    .then((res: any) => {
      if (res.status === 200 && res.data.success) {
        let url = '';
        store.dispatch({
          type: DESIGN.RESET,
        });
        resetAllData();
        console.log('getEditionArticles CampaignAssets > actions 2');
        getEditionArticles(res.data.email_id);
        if (window.location.pathname.includes('campaigns/content'))
          url = `/campaigns/editionedit/design/?campaign_id=${res.data.campaign_id}&email_id=${res.data.email_id}`;
        else url = `/campaigns/content/?campaign_id=${res.data.campaign_id}&email_id=${res.data.email_id}`;
        store.dispatch({
          type: ADHOC.RESET_URL,
          redirectUrl: url,
        });
        store.dispatch({
          type: CAMPAIGNS_LIST.UPDATE_ASSET_COUNT,
          campaign_id: res.data.campaign_id,
          add: true,
        });
        store.dispatch({
          type: GET_CAMPAIGNS_NAMES_ONLY.SUCCESS,
          payload: [
            {
              campaign_id: res.data.campaign_id,
              name: res.data.campaign_data.campaign_name,
            },
          ],
          newlyAdded: true,
        });
        const serializedCampaign = createNewCampaignSerialize(res.data.campaign_data, 1);
        store.dispatch({
          type: CAMPAIGNS_LIST.ADD_NEW,
          payload: serializedCampaign,
        });
      }
      closeOverlay();
    })
    .catch((err) => {
      console.log(err);
      closeOverlay();
      store.dispatch({
        type: ADHOC.SAVE_FAIL,
      });
    });
};

export const saveAIEmailAssetAPIAndCampaign = (
  emailName: string,
  campaignName: string,
  campaignId: number,
  prompt: string,
  contactIds?: any[],
  listIds?: any[],
) => {
  // Save adhoc asset with template associations
  store.dispatch({
    type: AIEMAIL.SET_LOADING,
    payload: { loading: true },
  });
  createAIEmailAndCampaignService(emailName, campaignName, campaignId, prompt, contactIds, listIds)
    .then((res: any) => {
      if (res.status === 200 && res.data.success) {
        const { emails, generation_id, campaign_id, email_name } = res.data.data;
        const mappedEmails = emails.map((email: any) => {
          return {
            emailId: email.email_id,
            AIType: email.ai_type,
            audienceCount: email.audience_count,
            isVisited: false,
            emailSubject: email.email_subject,
            color: email.color,
            thumbnail: email.thumbnail,
            audience: [],
            prompt: email.prompt.trim(),
          };
        });
        store.dispatch({
          type: AIEMAIL.AIEMAIL_SUCCESS,
          payload: {
            emails: mappedEmails,
            generationId: generation_id,
            emailName: email_name,
            campaignId: campaign_id,
          },
        });
        let url = `/campaigns/editionedit/design/?campaign_id=${campaign_id}&email_id=${emails[0]?.email_id}&generation_id=${generation_id}`;
        store.dispatch({
          type: DESIGN.RESET,
        });
        resetAllData();
        store.dispatch({
          type: ADHOC.RESET_URL,
          redirectUrl: url,
        });
        store.dispatch({
          type: CAMPAIGNS_LIST.UPDATE_ASSET_COUNT,
          campaign_id: campaign_id,
          add: true,
          emailCount: emails.length,
        });
        if (campaignName) {
          const resCampaignName = res.data?.data?.campaign_name;
          store.dispatch({
            type: GET_CAMPAIGNS_NAMES_ONLY.SUCCESS,
            payload: [
              {
                campaign_id: campaign_id,
                name: resCampaignName,
              },
            ],
            newlyAdded: true,
          });

          const serializedCampaign = createNewCampaignSerialize({ campaign_id: campaign_id, campaign_name: resCampaignName }, emails.length);
          store.dispatch({
            type: CAMPAIGNS_LIST.ADD_NEW,
            payload: serializedCampaign,
          });
        }
      }
      closeOverlay();
    })
    .catch((err) => {
      console.log(err);
      closeOverlay();
      store.dispatch({
        type: AIEMAIL.SET_LOADING,
        payload: { loading: false },
      });
    });
};

export const getAIEmailsAPI = (generationId: string) => {
  store.dispatch({
    type: AIEMAIL.RESET,
  });
  getAIEmailService(generationId)
    .then((res: any) => {
      if (res.data.success) {
        const { emails, generation_id, campaign_id, email_name } = res.data.data;
        const mappedEmails = emails.map((email: any) => {
          return {
            emailId: email.email_id,
            AIType: email.ai_type,
            audienceCount: email.audience_count,
            isVisited: email.is_reviewed ? true : false,
            emailSubject: email.email_subject,
            color: email.color,
            thumbnail: email.thumbnail,
            audience: [],
            prompt: email.prompt.trim(),
          };
        });
        store.dispatch({
          type: AIEMAIL.AIEMAIL_SUCCESS,
          payload: {
            emails: mappedEmails,
            generationId: generation_id,
            emailName: email_name,
            campaignId: campaign_id,
          },
        });
      }
      closeOverlay();
    })
    .catch((err) => {
      console.log(err);
      closeOverlay();
      store.dispatch({
        type: AIEMAIL.SET_LOADING,
        payload: { loading: false },
      });
    });
};

export const saveAsDraftAiEmail = (generationId: string, emailName?: string, campaignId?: string, campaignName?: string) => {
  saveAsDraftAiEmailService(generationId, emailName, campaignId, campaignName)
    .then((res: any) => {
      if (res.data.success) {
        message.success({
          content: 'Your email has been saved',
        });
        store.dispatch({
          type: CAMPAIGNS_LIST.UPDATE_ASSET_COUNT,
          campaign_id: res.data.data.campaign_id,
          add: true,
        });
        store.dispatch({
          type: EMAIL_LIST.RESET,
          payload: true,
        });
      }
    })
    .catch((err) => {
      message.error({
        content: 'Your email has not been saved',
      });
      console.log(err);
    });
};

export const setAIEmailDesign = (emailId: string, emailDesign: IDesignItem) => {
  store.dispatch({
    type: AIEMAIL.SET_DESIGN,
    payload: {
      emailId: emailId,
      emailDesign: emailDesign,
    },
  });
};

export const updateAIEmailDesign = (emailId: string, emailDesign: IDesignItem) => {
  store.dispatch({
    type: AIEMAIL.UPDATE_DESIGN,
    payload: {
      updateEmailId: emailId,
      updateEmailDesign: emailDesign,
    },
  });
};

export const setAIEmailVisited = (emailId: number) => {
  store.dispatch({
    type: AIEMAIL.EMAIL_VISITED,
    payload: emailId,
  });
  setAIEmailReviewService(emailId.toString(), true);
};

export const updateAiEmailSubject = (emailId: number, subject: string) => {
  updateAssetAndCampaignService({ asset_id: emailId.toString(), subject })
    .then((res) => {
      if (res.data.success) {
        store.dispatch({
          type: AIEMAIL.UPDATE_SUBJECT,
          payload: { emailIdUpdate: emailId, updatedSubject: subject },
        });
      }
    })
    .catch((err) => {
      console.log(err);
    });
};

export const resetAIEmail = () => {
  store.dispatch({
    type: AIEMAIL.RESET,
  });
};

export const resetTestCampaignKeywords = () => {
  store.dispatch({
    type: TEST_CAMPAIGN_SEARCH_TERM.RESET,
  });
};

export const resetIncludedKeywords = () => {
  return {
    type: SEARCH_ARTICLES.CLEAR_INCLUDED_KEYWORDS,
  };
};

export const setSelectedSelectAllRecommendedContacts = (contacts?: any[]) => {
  store.dispatch({
    type: SELECTED_RECOMMENDED_CONTACTS.SELECT_ALL_RECOMMENDED,
    payload: contacts,
  });
};

export const setSelectedUnSelectAllRecommendedContacts = () => {
  store.dispatch({
    type: SELECTED_RECOMMENDED_CONTACTS.UNSELECT_ALL_RECOMMENDED,
  });
  setTimeout(() => {
    store.dispatch({ type: SELECTED_RECOMMENDED_CONTACTS.RESET_SELECT_ALL_RECOMMENDED });
  }, 2000);
};

export const setSelectedSelectAllRecommendedSearchedContacts = (contacts?: any[]) => {
  store.dispatch({
    type: SELECTED_RECOMMENDED_CONTACTS.SELECT_ALL_SEARCHED,
    payload: contacts,
  });
};

export const setSelectedUnSelectAllRecommendedSearchedContacts = () => {
  store.dispatch({
    type: SELECTED_RECOMMENDED_CONTACTS.UNSELECT_ALL_SEARCHED,
  });
  setTimeout(() => {
    store.dispatch({ type: SELECTED_RECOMMENDED_CONTACTS.RESET_SELECT_ALL_SEARCHED });
  }, 2000);
};
export const setSelectedSelectAllRecommendedDynamicContacts = (contacts?: any[]) => {
  store.dispatch({
    type: SELECTED_RECOMMENDED_CONTACTS.SELECT_ALL_DYNAMIC,
    payload: contacts,
  });
};

export const setSelectedUnSelectAllRecommendedDynamicContacts = () => {
  store.dispatch({
    type: SELECTED_RECOMMENDED_CONTACTS.UNSELECT_ALL_DYNAMIC,
  });
  setTimeout(() => {
    store.dispatch({ type: SELECTED_RECOMMENDED_CONTACTS.RESET_SELECT_ALL_DYNAMIC });
  }, 2000);
};

export const resetSelectAllRecommendedContactsAction = () => {
  store.dispatch({
    type: SELECTED_RECOMMENDED_CONTACTS.RESET_ALL,
  });
};

export const resetEmailNameExists = (isExist: boolean) => {
  store.dispatch({
    type: SAVING_DESIGN.EMAIL_NAME_ALREADY_EXIST,
    emailAlreadyExist: isExist,
  });
};
